import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { getAllCards } from "../../services/api";
import { useAddCard, useSetDefaultCard } from "../../services/mutations";
import Button from "../Button";
import Dropdown from "../Dropdown";
import Input from "../Input";
import TextView from "../TextView";
import "./styles.css";
import DialogActions from "@mui/material/DialogActions";

const Wrapper = styled.div`
  margin-top: 20px;
  padding: 20px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;

const Label = styled(TextView)`
  font-size: 14px;
`;
const InputContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: end;
  align-items: center;

  button {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const CancelButton = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #495057;
  font-family: "DM Sans", sans-serif;
  cursor: pointer;
`;

export default function PaymentForm({ onCancel }) {
  const stripe = useStripe();
  const elements = useElements();
  const addCard = useAddCard();
  const makeDefault = useSetDefaultCard();

  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [cardComplete, setCardComplete] = useState(false);
  const [expiryComplete, setExpiryComplete] = useState(false);
  const [cvcComplete, setCvcComplete] = useState(false);

  const [error, setError] = useState(false);

  const isDisabled = !name || !cardComplete || !expiryComplete || !cvcComplete;

  // const onSetDefaultCard = () => {
  //   makeDefault.mutate(
  //     {
  //       payment_method: defaultCard,
  //     },
  //     {
  //       onSuccess: (res) => {
  //         toast.success("Card set as default.");
  //       },
  //       onError: (err) => {
  //         console.log(err);
  //       },
  //     }
  //   );
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!name) return setError(true);
    setError(false);
    setIsLoading(true);
    try {
      const { paymentMethod } = await stripe?.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardNumberElement),
        billing_details: {
          name: name,
        },
      });

      addCard.mutateAsync(
        {
          payment_method: paymentMethod.id,
        },
        {
          onSuccess: (res) => {
            console.log("res", res);
            toast.success("Card saved successfully!");
            setIsLoading(false);
            onCancel();
            // fetchCards();
          },
          onError: (err) => {
            console.log("err", err);
            setIsLoading(false);
          },
        }
      );
    } catch (error) {
      toast.error("Some error occurred. Please try again.");
      console.log(error);
      setIsLoading(false);
    }
  };

  return (
    <Wrapper>
      <form id="payment-form" onSubmit={handleSubmit}>
        <div>
          <Row>
            <Input
              label="Card Holder Name"
              labelStyle={{ fontSize: 14 }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ border: error && "1px solid red" }}
              placeholder="Full Name"
            />
            <InputContainer>
              <Label>Card Number</Label>

              <CardNumberElement
                options={{ showIcon: true }}
                showIcon={true}
                onChange={(e) => setCardComplete(e.complete)}
              />
            </InputContainer>
          </Row>
          <Row>
            <InputContainer>
              <Label>Expiry</Label>

              <CardExpiryElement
                onChange={(e) => setExpiryComplete(e.complete)}
              />
            </InputContainer>
            <InputContainer>
              <Label>CVV</Label>

              <CardCvcElement onChange={(e) => setCvcComplete(e.complete)} />
            </InputContainer>
          </Row>
        </div>

        <StyledDialogActions>
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
          <Button
          style={{ width: 80 }}
            isLoading={isLoading}
            type="submit"
            disabled={isDisabled}
          >
            Add
          </Button>
        </StyledDialogActions>
      </form>
    </Wrapper>
  );
}
